import { useTranslation } from "react-i18next";

import type { TeamMember } from "../../../lib/queries/team";

export function MemberInvitationHistory({ member }: { member: TeamMember }) {
  const { t, i18n } = useTranslation();
  const date = (value: string) =>
    new Intl.DateTimeFormat(i18n.language, {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(new Date(value));
  return (
    <div className="mt-2 space-y-2 text-xs text-slate-600">
      {member.invited_at && <p>{t("team.history.proposed", { date: date(member.invited_at) })}</p>}
      {member.accepted_at && (
        <p>{t("team.history.accepted", { date: date(member.accepted_at) })}</p>
      )}
      {member.invitation_history?.events[0] && (
        <p>
          {t("team.history.latest", {
            date: date(
              member.invitation_history.events[0].sent_at ??
                member.invitation_history.events[0].created_at,
            ),
            status: t(`team.history.status.${member.invitation_history.events[0].status}`),
          })}
        </p>
      )}
      {member.invitation_history && (
        <details>
          <summary className="focus-visible:ring-brand-500 min-h-11 cursor-pointer py-3 focus-visible:ring-2">
            {t("team.history.title")}
          </summary>
          <p>{t("team.history.meaning")}</p>
          {member.invitation_history.events.length === 0 && <p>{t("team.history.unknown")}</p>}
          <ol className="space-y-3 py-2">
            {member.invitation_history.events.map((event, index) => (
              <li key={`${event.created_at}-${index}`} className="border-l-2 border-slate-200 pl-3">
                <p>{t("team.history.created", { date: date(event.created_at) })}</p>
                <p>{t(`team.history.status.${event.status}`)}</p>
                {event.sent_at && <p>{t("team.history.sent_at", { date: date(event.sent_at) })}</p>}
                {event.delivery_status && (
                  <p>
                    {t(`team.history.delivery.${event.delivery_status}`)}
                    {event.delivery_updated_at && ` · ${date(event.delivery_updated_at)}`}
                  </p>
                )}
                <p>{t("team.history.attempts", { count: event.attempts })}</p>
              </li>
            ))}
          </ol>
          {member.invitation_history.truncated && <p>{t("team.history.limited")}</p>}
        </details>
      )}
    </div>
  );
}
